// jshint ignore: start
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import * as appHelper from "../../../helpers/appHelper";
import * as kpiHelper from "../../../helpers/kpiHelper";
import * as kpiModels from "../../../models/kpiModels";
import * as kpiConstants from "../../../constants/kpiConstants";
export class PrototypeKpi extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            feedback_styles: props.feedback_styles,
            meterParams: kpiModels.PRIMARY_KPI_ROTATION_METER_PARAMS,
            kpiSettings:{
                min: 0,
                max: 100,
                yellow: 50,
                green: 80,
                metric: "preview"
            }
        };
        this.renderSvg = this.renderSvg.bind(this);
    }

    componentDidMount() {
        this.renderSvg();
    }

    componentWillReceiveProps(nextProps) {

    }

    renderSvg() {
        this.setState({renderSvg:false});
        let redZone = this.refs[`kpiRedZone_${this.state.kpiSettings.metric}_${this.state.guid}`];
        let yellowZone = this.refs[`kpiYellowZone_${this.state.kpiSettings.metric}_${this.state.guid}`];
        let greenZone = this.refs[`kpiGreenZone_${this.state.kpiSettings.metric}_${this.state.guid}`];
        let autoAdjust = this.state.kpiSettings.min !== 0;
        redZone.setAttribute("d", kpiHelper.describeArc(
            this.state.meterParams.svgX,
            this.state.meterParams.svgY,
            this.state.meterParams.svgRadius,
            kpiHelper.getRotationAngle(this.state.meterParams.maxRotation, this.state.kpiSettings.min, this.state.kpiSettings.min, this.state.kpiSettings.max),
            kpiHelper.getRotationAngle(this.state.meterParams.maxRotation, this.state.kpiSettings.min, this.state.kpiSettings.yellow, this.state.kpiSettings.max)
        ));
        yellowZone.setAttribute("d", kpiHelper.describeArc(
            this.state.meterParams.svgX,
            this.state.meterParams.svgY,
            this.state.meterParams.svgRadius,
            kpiHelper.getRotationAngle(this.state.meterParams.maxRotation, this.state.kpiSettings.min, this.state.kpiSettings.yellow, this.state.kpiSettings.max),
            kpiHelper.getRotationAngle(this.state.meterParams.maxRotation, this.state.kpiSettings.min, this.state.kpiSettings.green, this.state.kpiSettings.max)
        ));
        greenZone.setAttribute("d", kpiHelper.describeArc(
            this.state.meterParams.svgX,
            this.state.meterParams.svgY,
            this.state.meterParams.svgRadius,
            kpiHelper.getRotationAngle(this.state.meterParams.maxRotation, this.state.kpiSettings.min, this.state.kpiSettings.green, this.state.kpiSettings.max),
            kpiHelper.getRotationAngle(this.state.meterParams.maxRotation, this.state.kpiSettings.min, this.state.kpiSettings.max, this.state.kpiSettings.max)
        ));
    }


    render() {
        return (
            <div className={`${this.state.meterParams.className}`} >
                <div className="kpi-rotation-meter">
                    <svg className={`kpi-svg`}>
                        <path ref={`kpiRedZone_${this.state.kpiSettings.metric}_${this.state.guid}`} fill="none"
                              strokeWidth={this.state.meterParams.svgStroke}
                              stroke={this.state.feedback_styles.red_feedback.colors.color}/>
                        <path ref={`kpiYellowZone_${this.state.kpiSettings.metric}_${this.state.guid}`} fill="none"
                              strokeWidth={this.state.meterParams.svgStroke}
                              stroke={this.state.feedback_styles.yellow_feedback.colors.color}/>
                        <path ref={`kpiGreenZone_${this.state.kpiSettings.metric}_${this.state.guid}`} fill="none"
                              strokeWidth={this.state.meterParams.svgStroke}
                              stroke={this.state.feedback_styles.green_feedback.colors.color}/>
                    </svg>
                    <div className="rotator" ref={`rotator_${this.state.kpiSettings.metric}_${this.state.guid}`}/>
                </div>

                <div className={`kpi-points-awarded  guroo-kpi-label`}>
                    KPI
                </div>

            </div>

        );
    }
}

PrototypeKpi.propTypes = {
    feedback_styles: PropTypes.object,
};


//Pull in the React Router context so router is available on this.context.router.
PrototypeKpi.contextTypes = {
    router: PropTypes.object
};

//Init
function mapStateToProps(state, ownProps) {
    return {
        feedback_styles: state.contentData.experience.feedback_styles,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, {}), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PrototypeKpi);


/** WEBPACK FOOTER **
 ** ./src/components/objects/prototypeObjects/PrototypeKpi.js
 **/